import { InformationCircleIcon } from "@heroicons/react/24/outline";
import React from "react";

const JobClosed = () => (
  <div className="container">
    <div className="my-12 p-6 bg-gray-50 rounded-lg shadow-sm border border-gray-100">
      <div className="flex items-center space-x-4">
        <div className="flex-shrink-0">
          <InformationCircleIcon className="h-12 w-12 text-blue-700" />
        </div>
        <div>
          <h2 className="text-lg font-semibold text-gray-900 mb-1">
            This position is no longer accepting applications
          </h2>
          <p className="text-gray-600">
            Thank you for your interest. This job posting has been closed or is
            currently not published. Please check back later for other
            opportunities.
          </p>
        </div>
      </div>
    </div>
  </div>
);

export default JobClosed;
